import { render, staticRenderFns } from "./MailNotifyTemplates.vue?vue&type=template&id=01cbf3a4&"
import script from "./MailNotifyTemplates.vue?vue&type=script&lang=ts&"
export * from "./MailNotifyTemplates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports